import React from "react";

const amendmentRoutes = [
    {
        path: "/applications/amendment/list",
        component: React.lazy(() => import("./AmendmentList")),
    },
    {
        path: "/applications/amendment/:viewType/:appId",
        component: React.lazy(() => import("./AmendmentFormDetails")),
    },
];

export default amendmentRoutes;